<template>
  <ConfirmPopup></ConfirmPopup>
  <div class="dashboard-view">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-content">
        <div class="title-section">
          <h1 class="title">Dashboard</h1>
          <!-- <p class="subtitle">
            A live snapshot of your connector, governance, and publishing flow.
          </p> -->
        </div>
        <div class="header-actions">
          <div class="status-chip" :class="dlmStoreStatusClass">
            <span class="status-dot" aria-hidden="true"></span>
            DLM Store: {{ dlmStoreStatusLabel }}
          </div>
          <!-- <button class="action-btn" @click="emit('open-assets-connector')">
            <i class="pi pi-database"></i>
            Create Asset
          </button>
          <button class="action-btn" @click="emit('open-policies-connector')">
            <i class="pi pi-shield"></i>
            Create Policy
          </button>
          <button class="action-btn" @click="emit('open-offers-connector')">
            <i class="pi pi-tag"></i>
            Publish Offer
          </button> -->
        </div>
      </div>
    </div>

    <!-- Stats Cards -->
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-title">Data Assets</span>
          <i class="pi pi-database stat-icon"></i>
        </div>
        <div class="stat-value">{{ uniqueAssetsCount }}</div>
        <div class="stat-meta">
          <button
            type="button"
            class="pill pill--button"
            @click="emit('open-assets-connector')"
          >
            {{ connectorAssetsCount }} connector
          </button>
          <button
            type="button"
            class="pill pill--button"
            @click="emit('open-assets-store')"
          >
            {{ storeAssetsCount }} store
          </button>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-title">Policies</span>
          <i class="pi pi-shield stat-icon"></i>
        </div>
        <div class="stat-value">{{ uniquePoliciesCount }}</div>
        <div class="stat-meta">
          <button
            type="button"
            class="pill pill--button"
            @click="emit('open-policies-connector')"
          >
            {{ connectorPoliciesCount }} connector
          </button>
          <button
            type="button"
            class="pill pill--button"
            @click="emit('open-policies-store')"
          >
            {{ storePoliciesCount }} store
          </button>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-title">Offers</span>
          <i class="pi pi-tag stat-icon"></i>
        </div>
        <div class="stat-value">{{ uniqueOffersCount }}</div>
        <div class="stat-meta">
          <button
            type="button"
            class="pill pill--button"
            @click="emit('open-offers-connector')"
          >
            {{ connectorOffersCount }} connector
          </button>
          <button
            type="button"
            class="pill pill--button"
            @click="emit('open-offers-store')"
          >
            {{ storeOffersCount }} store
          </button>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-title">Contracts</span>
          <i class="pi pi-file stat-icon"></i>
        </div>
        <div class="stat-value">{{ contractNegotiations.length }}</div>
        <div class="stat-meta">
          <span class="pill">{{ contractsActiveLabel }}</span>
        </div>
      </div>
    </div>

    <div class="stats-grid" v-if="url && did">
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-title">Connector Endpoint</span>
          <i class="pi pi-link stat-icon"></i>
        </div>
        <div>{{ url }}</div>
      </div>

      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-title">Participant DID</span>
          <i class="pi pi-user stat-icon"></i>
        </div>
        <div>{{ did }}</div>
      </div>
    </div>

    <!-- Connector Properties Section -->
    <!-- <div class="connector-section">
      <div class="section-header">
        <button
          type="button"
          class="section-toggle"
          @click="creatorOpen = !creatorOpen"
        >
          <span style="font-size: x-large">Connector Information</span>
          <svg
            class="toggle-icon"
            :class="{ open: creatorOpen }"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <transition name="fade-slide">
        <div class="connector-grid" v-if="creatorOpen">
          <div class="property-card">
            <div class="property-icon">
              <i class="pi pi-circle-on"></i>
            </div>
            <div class="property-content">
              <span class="property-label">Connector endpoint</span>
              <span class="property-value">{{ url }}</span>
            </div>
          </div>

          <div class="property-card">
            <div class="property-icon">
              <i class="pi pi-circle-on"></i>
            </div>
            <div class="property-content">
              <span class="property-label">IdentityHub URL</span>
              <span class="property-value">http://identity-hub.com</span>
            </div>
          </div>

          <div class="property-card">
            <div class="property-icon">
              <i class="pi pi-circle-on"></i>
            </div>
            <div class="property-content">
              <span class="property-label">Participant Id</span>
              <span class="property-value">{{ did }}</span>
            </div>
          </div>

          <div class="property-card">
            <div class="property-icon">
              <i class="pi pi-circle-on"></i>
            </div>
            <div class="property-content">
              <span class="property-label">Verifiable credentials</span>
              <span class="property-value"
                >did:web:provider-identityhub%3A7083:provider</span
              >
            </div>
          </div>
        </div>
      </transition>
    </div> -->
  </div>
</template>

<script setup>
import { getCurrentInstance, computed, defineEmits, ref } from "vue";
import ConfirmPopup from "primevue/confirmpopup";
import { useConfirm } from "primevue/useconfirm";

const { appContext } = getCurrentInstance();
const API_BASE_URL = appContext.config.globalProperties.$apiBase;
const confirm = useConfirm();
const creatorOpen = ref(false);

const emit = defineEmits([
  "open-assets-connector",
  "open-assets-store",
  "open-policies-connector",
  "open-policies-store",
  "open-offers-connector",
  "open-offers-store",
]);

const props = defineProps({
  assets: {
    type: Array,
    required: true,
  },
  user: {
    type: String,
    required: true,
  },
  policies: {
    type: Array,
    required: false,
  },
  storeAssets: {
    type: Array,
    required: false,
    default: () => [],
  },
  storeOffers: {
    type: Array,
    required: false,
    default: () => [],
  },
  storePolicies: {
    type: Array,
    required: false,
    default: () => [],
  },
  dlmStoreStatus: {
    type: Object,
    required: false,
    default: () => ({
      state: "unknown",
      message: "Checking",
      lastChecked: null,
    }),
  },
  contractDefinitions: {
    type: Array,
    required: false,
  },
  contractNegotiations: {
    type: Array,
    required: false,
  },
  contractInfo: {
    type: Array,
    required: false,
  },
});

const url = computed(() => props.contractInfo[0]?.url);
const did = computed(() => props.contractInfo[0]?.participantId);
const storeAssetsCount = computed(() => props.storeAssets.length);
const connectorAssetsCount = computed(() => props.assets.length);
const storeOffersCount = computed(() => props.storeOffers.length);
const storePoliciesCount = computed(() => props.storePolicies.length);
const connectorPoliciesCount = computed(() => props.policies.length);
const contractsActiveLabel = computed(() =>
  props.contractNegotiations.length ? "active" : "none yet"
);

const dlmStoreStatusLabel = computed(() => {
  if (props.dlmStoreStatus?.state === "online") return "Online";
  if (props.dlmStoreStatus?.state === "offline") return "Offline";
  return "Checking";
});

const dlmStoreStatusClass = computed(() => {
  if (props.dlmStoreStatus?.state === "online") return "status-chip--ok";
  if (props.dlmStoreStatus?.state === "offline") return "status-chip--warn";
  return "status-chip--muted";
});

const getStoreAssetId = (asset) =>
  asset?.externalId || asset?.contentData?.["@id"] || asset?.id;
const getStoreAssetName = (asset) => asset?.name || asset?.contentData?.name;
const getConnectorAssetId = (asset) => asset?.id || asset?.properties?.id;
const getConnectorAssetName = (asset) => asset?.properties?.name;

const connectorAssetsById = computed(() => {
  const map = new Map();
  props.assets.forEach((asset) => {
    const key = getConnectorAssetId(asset);
    if (key) map.set(key, asset);
  });
  return map;
});

const connectorAssetsByName = computed(() => {
  const map = new Map();
  props.assets.forEach((asset) => {
    const key = getConnectorAssetName(asset);
    if (key) map.set(key, asset);
  });
  return map;
});

const matchedAssetsCount = computed(() => {
  let matches = 0;
  props.storeAssets.forEach((asset) => {
    const id = getStoreAssetId(asset);
    if (id && connectorAssetsById.value.has(id)) {
      matches += 1;
      return;
    }
    const name = getStoreAssetName(asset);
    if (name && connectorAssetsByName.value.has(name)) {
      matches += 1;
    }
  });
  return matches;
});

const uniqueAssetsCount = computed(
  () =>
    storeAssetsCount.value +
    connectorAssetsCount.value -
    matchedAssetsCount.value
);

const getStorePolicyId = (policy) =>
  policy?.externalId || policy?.contentData?.["@id"] || policy?.id;
const getStorePolicyName = (policy) =>
  policy?.name || policy?.contentData?.name;
const getConnectorPolicyId = (policy) =>
  policy?.["@id"] || policy?.policy?.["@id"];
const getConnectorPolicyName = (policy) => policy?.name;

const connectorPoliciesById = computed(() => {
  const map = new Map();
  props.policies.forEach((policy) => {
    const key = getConnectorPolicyId(policy);
    if (key) map.set(key, policy);
  });
  return map;
});

const connectorPoliciesByName = computed(() => {
  const map = new Map();
  props.policies.forEach((policy) => {
    const key = getConnectorPolicyName(policy);
    if (key) map.set(key, policy);
  });
  return map;
});

const matchedPoliciesCount = computed(() => {
  let matches = 0;
  props.storePolicies.forEach((policy) => {
    const id = getStorePolicyId(policy);
    if (id && connectorPoliciesById.value.has(id)) {
      matches += 1;
      return;
    }
    const name = getStorePolicyName(policy);
    if (name && connectorPoliciesByName.value.has(name)) {
      matches += 1;
    }
  });
  return matches;
});

const uniquePoliciesCount = computed(
  () =>
    storePoliciesCount.value +
    connectorPoliciesCount.value -
    matchedPoliciesCount.value
);

const getStoreOfferId = (offer) =>
  offer?.externalId || offer?.contentData?.["@id"] || offer?.id;
const getStoreOfferName = (offer) => offer?.name || offer?.contentData?.name;
const getConnectorOfferId = (offer) => offer?.["@id"] || offer?.id;
const getConnectorOfferName = (offer) => offer?.name;

const connectorOffersById = computed(() => {
  const map = new Map();
  props.contractDefinitions.forEach((offer) => {
    const key = getConnectorOfferId(offer);
    if (key) map.set(key, offer);
  });
  return map;
});

const connectorOffersByName = computed(() => {
  const map = new Map();
  props.contractDefinitions.forEach((offer) => {
    const key = getConnectorOfferName(offer);
    if (key) map.set(key, offer);
  });
  return map;
});

const matchedOffersCount = computed(() => {
  let matches = 0;
  props.storeOffers.forEach((offer) => {
    const id = getStoreOfferId(offer);
    if (id && connectorOffersById.value.has(id)) {
      matches += 1;
      return;
    }
    const name = getStoreOfferName(offer);
    if (name && connectorOffersByName.value.has(name)) {
      matches += 1;
    }
  });
  return matches;
});

const connectorOffersCount = computed(() => props.contractDefinitions.length);
const uniqueOffersCount = computed(
  () =>
    storeOffersCount.value +
    connectorOffersCount.value -
    matchedOffersCount.value
);
</script>

<style scoped>
.dashboard-view {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
  font-family: "Space Grotesk", "Manrope", "Helvetica Neue", sans-serif;
  color: #1a1a1a;
  background: radial-gradient(
      circle at 20% 20%,
      rgba(0, 150, 136, 0.08),
      transparent 45%
    ),
    radial-gradient(circle at 80% 0%, rgba(34, 211, 238, 0.1), transparent 40%);
}

/* Header Section */
.header-section {
  background: linear-gradient(135deg, #009688 0%, #00695c 100%);
  border-radius: 16px;
  padding: 2.5rem;
  margin-bottom: 2.5rem;
  color: white;
  box-shadow: 0 8px 32px rgba(0, 150, 136, 0.15);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: -0.5px;
}

.subtitle {
  margin: 0;
  opacity: 0.9;
  font-size: 1rem;
  max-width: 480px;
}

.header-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-left: auto;
  justify-content: flex-end;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  gap: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.12);
  color: #f8fafc;
}

.status-chip--ok {
  border-color: rgba(226, 232, 240, 0.6);
  background: rgba(15, 23, 42, 0.18);
}

.status-chip--warn {
  border-color: rgba(254, 215, 170, 0.6);
  background: rgba(30, 41, 59, 0.2);
}

.status-chip--muted {
  border-color: rgba(148, 163, 184, 0.5);
  background: rgba(148, 163, 184, 0.12);
  color: #e2e8f0;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #e2e8f0;
  box-shadow: 0 0 0 3px rgba(226, 232, 240, 0.15);
}

.status-chip--ok .status-dot {
  background: #22d3ee;
  box-shadow: 0 0 0 3px rgba(34, 211, 238, 0.2);
}

.status-chip--warn .status-dot {
  background: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

.status-chip--muted .status-dot {
  background: #cbd5f5;
  box-shadow: 0 0 0 3px rgba(203, 213, 245, 0.2);
}

.action-btn {
  border: none;
  border-radius: 999px;
  padding: 0.65rem 1.15rem;
  background: rgba(255, 255, 255, 0.14);
  color: white;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;
}

.action-btn:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.22);
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 150, 136, 0.12);
  border-color: #009688;
}

.stat-card--clickable {
  cursor: pointer;
}

.stat-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #009688, #00695c);
}

.stat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.stat-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-icon {
  font-size: 1.5rem;
  color: #009688;
  opacity: 0.8;
}

.stat-value {
  font-size: 3rem;
  font-weight: 700;
  color: #009688;
  line-height: 1;
}

.stat-meta {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.9rem;
  flex-wrap: wrap;
}

.pill {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  background: #eef7f6;
  color: #0f766e;
}

.pill--button {
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.pill--button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(15, 118, 110, 0.18);
}

/* Connector Section */
.connector-section {
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  border: 1px solid #e8e8e8;
}

.section-header {
  margin-bottom: 2rem;
}

.section-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -0.3px;
}

/* Connector Grid */
.connector-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 2fr));
  gap: 1.5rem;
}

.property-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.property-card:hover {
  background: white;
  border-color: #e0e0e0;
  transform: translateX(4px);
}
.section-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  color: #1e293b;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.section-toggle:hover {
  border-color: #009688;
  background: #f0fdfa;
}

.toggle-icon {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.toggle-icon.open {
  transform: rotate(180deg);
}
.property-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 10px;
  flex-shrink: 0;
}

.property-icon i {
  font-size: 0.75rem;
  color: #009688;
}

.property-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.property-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.property-value {
  font-size: 0.85rem;
  color: #888;
  font-family: "JetBrains Mono", "SF Mono", Monaco, Consolas, monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .dashboard-view {
    padding: 1.5rem;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .dashboard-view {
    padding: 1rem;
  }

  .header-section {
    padding: 1.5rem;
    margin-bottom: 2rem;
  }

  .title {
    font-size: 2rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .connector-section {
    padding: 1.5rem;
  }

  .section-title {
    font-size: 1.5rem;
  }

  .connector-grid {
    grid-template-columns: 1fr;
  }

  .stat-card {
    padding: 1.25rem;
  }

  .stat-value {
    font-size: 2.5rem;
  }
}

@media (max-width: 480px) {
  .title {
    font-size: 1.75rem;
  }

  .connector-section {
    padding: 1.25rem;
  }

  .property-card {
    padding: 1rem;
  }
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-card {
  animation: fadeIn 0.4s ease forwards;
}

.stat-card:nth-child(1) {
  animation-delay: 0.1s;
}
.stat-card:nth-child(2) {
  animation-delay: 0.2s;
}
.stat-card:nth-child(3) {
  animation-delay: 0.3s;
}
.stat-card:nth-child(4) {
  animation-delay: 0.4s;
}

.property-card {
  animation: fadeIn 0.4s ease forwards;
}

.property-card:nth-child(1) {
  animation-delay: 0.2s;
}
.property-card:nth-child(2) {
  animation-delay: 0.3s;
}
.property-card:nth-child(3) {
  animation-delay: 0.4s;
}
.property-card:nth-child(4) {
  animation-delay: 0.5s;
}
</style>
